const pt = {
  code: "pt",
  meta: {
    home: {
      title: "Bloom Beauty Concept Hair | Cabeleireiro na Venda do Pinheiro",
      desc: "Especialista em mechas, balayage, coloração, tratamentos, alinhamentos e progressiva na Venda do Pinheiro. Marque a sua avaliação com Monique Santos.",
    },
    sobre: {
      title: "Sobre Monique Santos | Bloom Beauty Concept Hair",
      desc: "Conheça Monique Santos, hairstylist responsável pela Bloom Beauty Concept Hair na Venda do Pinheiro. Atendimento personalizado e saúde capilar em primeiro lugar.",
    },
    servicos: {
      title: "Serviços | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Cortes, coloração, mechas e balayage, correção de cor, tratamentos, cronograma capilar, botox, alinhamentos e progressiva na Venda do Pinheiro.",
    },
    avaliacao: {
      title: "Avaliação Profissional | Bloom Beauty Concept Hair",
      desc: "Tudo começa por uma boa avaliação: diagnóstico do cabelo, histórico químico, teste de mecha e plano personalizado. Marque pelo WhatsApp.",
    },
    transformacoes: {
      title: "Transformações | Bloom Beauty Concept Hair",
      desc: "Resultados reais de mechas, balayage, coloração, alinhamentos e progressiva realizados na Bloom Beauty Concept Hair, Venda do Pinheiro.",
    },
    galeria: {
      title: "Galeria | Bloom Beauty Concept Hair",
      desc: "O espaço, os detalhes e o trabalho da Bloom Beauty Concept Hair na Venda do Pinheiro.",
    },
    contato: {
      title: "Contacto | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Rua Casal dos Ninhos 1B, Venda do Pinheiro. WhatsApp +351 963 085 891. Segunda a sexta 09:00–19:00, sábado 09:30–18:00.",
    },
    privacidade: {
      title: "Política de Privacidade | Bloom Beauty Concept Hair",
      desc: "Política de privacidade e proteção de dados da Bloom Beauty Concept Hair.",
    },
  },
  nav: {
    home: "Início",
    about: "Sobre",
    services: "Serviços",
    transformations: "Transformações",
    gallery: "Galeria",
    contact: "Contacto",
    book: "Marcar Avaliação",
    menu: "Menu",
    close: "Fechar",
  },
  common: {
    learnMore: "Saber mais",
    bookEval: "Marcar avaliação",
    bookService: "Marcar atendimento",
    whatsapp: "WhatsApp",
    instagram: "Instagram",
    directions: "Como chegar",
    call: "Ligar",
    send: "Enviar pedido",
    sending: "A enviar…",
    viewServices: "Conhecer serviços",
    seeTransformations: "Ver transformações",
    seeGallery: "Ver galeria",
    all: "Todos",
    backToServices: "Voltar aos serviços",
    includedNote: "Sem preços online: cada cabelo é único. Os valores são indicados após avaliação ou pelo WhatsApp.",
    soonGoogle: "Em breve — estamos a preparar o nosso perfil Google.",
  },
  home: {
    heroEyebrow: "Bloom Beauty Concept Hair — Venda do Pinheiro",
    heroLines: ["Cabelos que revelam", "a sua melhor", "versão."],
    heroText:
      "Especialista em cor, iluminação, tratamentos, alinhamentos e transformação capilar na Venda do Pinheiro.",
    ctaPrimary: "Marcar Avaliação",
    ctaSecondary: "Conhecer Serviços",
    scroll: "Deslize para descobrir",
    marquee: ["Mechas & Balayage", "Coloração", "Tratamentos Capilares", "Alinhamentos", "Progressiva", "Corte & Finalização"],
    welcome: {
      eyebrow: "Bem-vinda à Bloom",
      title: "Um conceito de beleza feito à sua medida",
      p: "A Bloom Beauty Concept Hair nasceu para oferecer uma experiência de beleza personalizada, onde cada cabelo é avaliado individualmente e cada transformação respeita a identidade, a saúde dos fios e o desejo de cada cliente.",
      tag: "Realçamos a sua beleza, revelamos a sua essência.",
    },
    specialties: {
      eyebrow: "Especialidades",
      title: "O que podemos fazer pelo seu cabelo",
      sub: "Técnicas personalizadas, produtos profissionais e um olhar atento à saúde dos fios.",
    },
    monique: {
      eyebrow: "A Hairstylist",
      title: "Conheça Monique Santos",
      p1: "Por trás da Bloom está Monique Santos, hairstylist apaixonada por valorizar a beleza e a identidade de cada mulher.",
      p2: "Cada atendimento começa com uma análise cuidadosa do cabelo, do histórico químico, dos objetivos da cliente e da saúde dos fios. O objetivo não é apenas transformar o visual, mas criar resultados bonitos, personalizados e sustentáveis.",
      cta: "Conhecer a Monique",
    },
    transformations: {
      eyebrow: "Portfólio",
      title: "Transformações que falam por si.",
      p: "Cada cabelo possui uma história. Cada resultado é construído de forma personalizada.",
    },
    experience: {
      eyebrow: "Experiência Bloom",
      title: "Cada detalhe, pensado para si",
      steps: [
        { n: "01", t: "Avaliação individual", d: "Antes de qualquer técnica, ouvimos a sua história e analisamos o seu cabelo." },
        { n: "02", t: "Técnica personalizada", d: "Cada serviço é adaptado ao seu fio, ao seu rosto e ao seu estilo de vida." },
        { n: "03", t: "Produtos profissionais", d: "Trabalhamos com gamas profissionais escolhidas para cada necessidade." },
        { n: "04", t: "Cuidado com a saúde do cabelo", d: "Beleza duradoura só existe com fios saudáveis — sempre." },
      ],
    },
    evaluation: {
      eyebrow: "Avaliação Profissional",
      title: "Tudo começa por uma boa avaliação.",
      p: "Determinados procedimentos precisam de uma análise profissional antes de qualquer transformação. É assim que protegemos a saúde dos seus fios e garantimos o resultado certo para si.",
      items: [
        "Diagnóstico do cabelo",
        "Análise do couro cabeludo",
        "Histórico químico",
        "Objetivo da cliente",
        "Plano personalizado",
        "Teste de mecha quando necessário",
        "Estimativa de tempo",
        "Orientação profissional",
      ],
      cta: "Marcar a minha avaliação",
    },
    salon: {
      eyebrow: "O Salão",
      title: "Um espaço criado para cuidar de si.",
      p: "Um ambiente acolhedor e elegante onde cada detalhe foi pensado para transformar o seu momento de beleza numa experiência especial.",
    },
    quote: "Cuidar do cabelo é mais que estética. É autoestima, é se lembrar de você.",
    final: {
      title: "Pronta para viver a experiência Bloom?",
      p: "Fale diretamente com Monique e marque a sua avaliação.",
      cta: "Agendar pelo WhatsApp",
    },
    quotes: [
      "Cuide de si com o mesmo carinho que oferece aos outros.",
      "A sua beleza começa quando você reconhece o seu próprio valor.",
      "Um novo cabelo pode ser o começo de uma nova energia.",
      "Reserve um momento para si. Você merece.",
      "Realce a sua beleza. Revele a sua essência.",
      "Quando você se sente bem consigo mesma, isso aparece por fora.",
      "Floresça na sua própria beleza.",
    ],
  },
  about: {
    eyebrow: "Sobre",
    title: "Mais que cabelo. Uma experiência de cuidado.",
    p1: "Por trás da Bloom Beauty Concept Hair está Monique Santos, hairstylist apaixonada por valorizar a beleza e a identidade de cada mulher que se senta na sua cadeira.",
    p2: "Cada atendimento começa com uma análise cuidadosa do cabelo, do histórico químico, dos objetivos da cliente e da saúde dos fios. O objetivo não é apenas transformar o visual, mas criar resultados bonitos, personalizados e sustentáveis — que façam sentido no dia a dia de quem os usa.",
    p3: "Na Bloom, acreditamos que a verdadeira transformação começa quando cada mulher se escolhe, se cuida e se honra. Aqui, cada detalhe é pensado para realçar quem já é.",
    philosophyTitle: "A minha filosofia",
    philosophy: "Cada mulher possui uma beleza única. O meu trabalho é compreender o seu estilo, o seu cabelo e o resultado que deseja alcançar para criar uma transformação que respeite a sua identidade.",
    valuesTitle: "O que pode esperar",
    values: [
      { t: "Escuta verdadeira", d: "O seu desejo e a sua rotina são o ponto de partida de cada proposta." },
      { t: "Saúde capilar primeiro", d: "Nenhuma transformação vale a saúde dos seus fios." },
      { t: "Atualização constante", d: "Técnicas e produtos em evolução, ao serviço do seu cabelo." },
      { t: "Transparência", d: "Avaliação honesta, sem promessas impossíveis." },
    ],
    coursesEyebrow: "Formação profissional",
    coursesTitle: "Monique Santos também é formadora",
    coursesText: "Além dos atendimentos no salão, Monique também ministra cursos profissionais nas áreas de tratamentos capilares e alisamento.",
    courseHairTreatments: "Curso de Tratamentos Capilares",
    courseStraightening: "Curso de Alisamento",
    lorenaEyebrow: "Profissional Bloom",
    lorenaTitle: "Conheça a Lorena",
    lorenaText: "Lorena integra a equipa Bloom e é profissional formada nas áreas de depilação a laser e limpeza de pele, com atendimento dedicado e personalizado.",
    lorenaLaser: "Depilação a Laser",
    lorenaSkin: "Limpeza de Pele",
    cta: "Falar com a Monique",
    quote: "Floresce a sua beleza.",
  },
  servicesPage: {
    eyebrow: "Serviços",
    title: "Um menu de cuidado para cada cabelo",
    sub: "Explore cada especialidade. Todos os serviços começam com escuta e, quando necessário, avaliação profissional — por isso não apresentamos preços online.",
  },
  services: {
    "cortes-finalizacao": {
      name: "Cortes & Finalização",
      short: "Cortes e styling que respeitam o seu rosto e o movimento natural do cabelo.",
      desc: "Cortes e finalizações pensados para valorizar o formato do rosto, o movimento do cabelo e o estilo de cada cliente.",
      items: [
        "Corte feminino", "Corte + secagem", "Corte + brushing", "Corte masculino",
        "Franja / ajuste de corte", "Secagem simples", "Brushing — cabelo curto",
        "Brushing — cabelo médio", "Brushing — cabelo longo",
        "Brushing — cabelo extra longo ou denso", "Piastra / finalização lisa", "Ondas / modelação",
      ],
      cta: "Marcar atendimento",
    },
    coloracao: {
      name: "Coloração",
      short: "Cores personalizadas que valorizam a pele, o estilo e a identidade.",
      desc: "Cores desenvolvidas de forma personalizada para valorizar a pele, o estilo e a identidade de cada cliente.",
      note: "Alguns serviços podem necessitar de avaliação prévia.",
      items: [
        "Coloração de raiz", "Coloração completa — cabelo curto", "Coloração completa — cabelo médio",
        "Coloração completa — cabelo longo", "Coloração — cabelo extra longo ou denso",
        "Tonalização / Gloss", "Banho de brilho", "Cobertura de brancos", "Coloração + corte + brushing",
      ],
      cta: "Marcar atendimento",
    },
    "mechas-balayage": {
      name: "Iluminações, Mechas & Balayage",
      short: "Iluminação à medida: do babylight subtil ao loiro total.",
      desc: "Iluminações criadas de acordo com o corte, tom de pele, base natural do cabelo e objetivo da cliente.",
      note: "Transformações de cor podem exigir avaliação e teste de mecha.",
      items: [
        "Mechas parciais", "Mechas completas", "Balayage", "Balayage Premium",
        "Contour / Face Framing", "Iluminação parcial", "Full Blonde", "Babylights",
        "Mechas + tonalização + brushing",
      ],
      cta: "Marcar avaliação",
    },
    "correcao-de-cor": {
      name: "Correção de Cor",
      short: "Recuperar, equilibrar e reconstruir a cor com segurança.",
      desc: "Corrigir uma cor é um processo técnico que exige diagnóstico, estratégia e respeito pela fibra capilar. Cada caso é estudado individualmente.",
      note: "Serviços complexos de correção devem ser avaliados individualmente.",
      items: [
        "Correção de cor simples", "Correção de cor média", "Correção de cor complexa",
        "Descoloração global", "Remoção de pigmento", "Transformação de cor", "Correção + reconstrução",
      ],
      cta: "Marcar avaliação",
    },
    "tratamentos-capilares": {
      name: "Tratamentos Capilares",
      short: "Hidratação, nutrição e reconstrução para fios visivelmente saudáveis.",
      desc: "Rituais de tratamento escolhidos de acordo com a necessidade real do seu cabelo — porque nenhum fio é igual ao outro.",
      items: [
        "Hidratação", "Nutrição", "Reconstrução", "Tratamento anti-frizz", "Detox capilar",
        "Cauterização", "Reconstrução intensiva", "Tratamento premium", "Tratamento + brushing",
      ],
      highlights: [
        { t: "Hidratação", d: "Reposição de água para fios macios e flexíveis." },
        { t: "Nutrição", d: "Reposição de lipídios para brilho e disciplina." },
        { t: "Reconstrução", d: "Reposição de massa e proteínas para força e estrutura." },
      ],
      cta: "Marcar atendimento",
    },
    "cronograma-capilar": {
      name: "Cronograma Capilar",
      short: "Um plano de sessões pensado para a recuperação do seu cabelo.",
      desc: "Um programa de cuidado sequencial que combina hidratação, nutrição e reconstrução na medida exata do seu fio.",
      items: ["Cronograma de 3 sessões", "Cronograma de 4 sessões", "Cronograma Premium", "Sessão individual"],
      process: ["Avaliação", "Diagnóstico", "Plano personalizado", "Sessões", "Manutenção"],
      cta: "Marcar avaliação",
    },
    "botox-alinhamento": {
      name: "Botox & Alinhamento",
      short: "Fios alinhados, brilhantes e sem frizz — com tecnologia Bloom.",
      desc: "Do botox capilar ao Realinhamento Bloom: tecnologias de alinhamento que devolvem disciplina, brilho e maciez, respeitando a saúde do fio.",
      note: "As opções variam conforme o comprimento e a densidade do cabelo — definidos em avaliação.",
      items: ["Botox capilar", "Botox Premium", "Selagem", "Alinhamento", "Tratamento anti-frizz"],
      cta: "Marcar avaliação",
    },
    "progressiva-alisamentos": {
      name: "Progressiva & Alisamentos",
      short: "Liso natural, com movimento e sem frizz, todos os dias.",
      desc: "Cabelos alinhados, brilhantes, macios e sem frizz, todos os dias. A técnica certa — progressiva, alisamento orgânico ou premium — é escolhida após avaliação do fio.",
      note: "Serviços separados por comprimento e densidade — valores apenas após avaliação.",
      items: ["Progressiva", "Alisamento orgânico", "Alisamento Premium", "Realinhamento Bloom"],
      cta: "Marcar avaliação",
    },
    "depilacao-a-laser": {
      name: "Depilação a Laser",
      short: "Sessões de depilação a laser realizadas pela profissional Lorena.",
      desc: "Um cuidado pensado para quem procura reduzir os pelos de forma progressiva, com atendimento personalizado e acompanhamento profissional.",
      professional: "Com a profissional Lorena",
      note: "O protocolo e a frequência das sessões são definidos individualmente após avaliação.",
      items: ["Avaliação inicial", "Plano de sessões personalizado", "Depilação a laser por zonas", "Acompanhamento entre sessões"],
      cta: "Marcar com a Lorena",
      waMessage: "Olá! Vi o website da Bloom e gostaria de obter informações ou marcar depilação a laser com a Lorena.",
    },
    "limpeza-de-pele": {
      name: "Limpeza de Pele",
      short: "Cuidado facial personalizado realizado pela profissional Lorena.",
      desc: "Uma experiência de cuidado facial focada na limpeza, preparação e conforto da pele, adaptada às necessidades de cada cliente.",
      professional: "Com a profissional Lorena",
      items: ["Avaliação da pele", "Higienização", "Limpeza e cuidado facial", "Máscara facial", "Finalização e orientação de cuidados"],
      cta: "Marcar com a Lorena",
      waMessage: "Olá! Vi o website da Bloom e gostaria de obter informações ou marcar uma limpeza de pele com a Lorena.",
    },
    avaliacao: {
      name: "Avaliação Profissional",
      short: "O ponto de partida de qualquer transformação segura.",
      desc: "Diagnóstico completo do cabelo e do couro cabeludo, com teste de mecha incluído quando necessário.",
    },
  },
  avaliacaoPage: {
    eyebrow: "Avaliação Profissional",
    title: "Tudo começa por uma boa avaliação.",
    p: "Antes de qualquer transformação de cor, alisamento ou tratamento intensivo, analisamos em detalhe o seu cabelo. É este cuidado que torna os resultados bonitos, seguros e duradouros.",
    itemsTitle: "O que analisamos",
    items: [
      { t: "Condição dos fios", d: "Elasticidade, porosidade, força e nível de dano." },
      { t: "Couro cabeludo", d: "Observação do estado geral do couro cabeludo." },
      { t: "Histórico químico", d: "Colorações, descolorações e alisamentos anteriores." },
      { t: "Objetivo da cliente", d: "O resultado que deseja e o que é viável alcançar." },
      { t: "Técnica e etapas", d: "Definição da técnica, do tempo e das possíveis fases." },
      { t: "Teste de mecha", d: "Sempre que necessário, antes de procedimentos químicos." },
      { t: "Manutenção", d: "Orientações para manter o resultado em casa." },
    ],
    cta: "Agendar avaliação pelo WhatsApp",
  },
  transformationsPage: {
    eyebrow: "Transformações",
    title: "Transformações que falam por si.",
    p: "Resultados reais, construídos de forma personalizada. Cada cabelo possui uma história — estas são algumas delas.",
    filters: { all: "Todas", antesDepois: "Antes & Depois", coloracao: "Coloração", balayage: "Balayage", progressiva: "Progressiva", cortes: "Cortes" },
    slider: { before: "Antes", after: "Depois" },
    captions: {
      balayage: "Balayage",
      progressiva: "Progressiva Orgânica",
      corteBob: "Corte Bob Curto Invertido",
      colocacao: "Colocação",
      loiro: "Loiro",
      ruiva: "Coloração Ruiva",
      videoLoiro: "Loiro — sem filtro",
      videoProg: "Progressiva Orgânica",
      videoRuiva: "Coloração Ruiva",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  galleryPage: {
    eyebrow: "Galeria",
    title: "O universo Bloom em imagens",
    p: "O espaço, os detalhes, os trabalhos e a essência da Bloom Beauty Concept Hair.",
    tags: { all: "Tudo", coloracao: "Coloração", balayage: "Balayage", progressiva: "Progressiva", cortes: "Cortes" },
    captions: {
      balayage: "Balayage",
      progressiva: "Progressiva Orgânica",
      corteBob: "Corte Bob Curto Invertido",
      colocacao: "Colocação",
      loiro: "Loiro",
      ruiva: "Coloração Ruiva",
      videoLoiro: "Loiro — sem filtro",
      videoProg: "Progressiva Orgânica",
      videoRuiva: "Coloração Ruiva",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  contactPage: {
    eyebrow: "Contacto",
    title: "Vamos conversar sobre o seu cabelo?",
    p: "Estamos na Venda do Pinheiro, de portas abertas para si. Fale connosco pelo WhatsApp, Instagram ou através do formulário.",
    addressTitle: "Morada",
    phoneTitle: "Telefone / WhatsApp",
    hoursTitle: "Horário",
    hoursWeek: "Segunda a sexta",
    hoursWeekTime: "09:00 – 19:00",
    hoursSat: "Sábado",
    hoursSatTime: "09:30 – 18:00",
    formTitle: "Enviar pedido",
    form: {
      name: "Nome", namePh: "O seu nome",
      phone: "Telefone", phonePh: "+351 …",
      email: "Email", emailPh: "oseuemail@exemplo.com",
      service: "Serviço de interesse",
      message: "Mensagem", messagePh: "Conte-nos o que procura…",
      submit: "Enviar pedido",
      success: "Pedido enviado! Responderemos com a maior brevidade. Se preferir, fale já connosco pelo WhatsApp.",
      error: "Não foi possível enviar. Tente novamente ou fale connosco pelo WhatsApp.",
      required: "Preencha o nome e a mensagem, por favor.",
    },
    serviceOptions: ["Corte", "Coloração", "Mechas", "Balayage", "Correção de Cor", "Tratamento", "Cronograma", "Botox", "Alinhamento", "Progressiva", "Avaliação", "Outro"],
    whatsappCta: "Falar pelo WhatsApp",
    googleCta: "Avaliar-nos no Google",
    googleTitle: "Bloom no Google",
    googleRating: "★★★★★ 5,0 · 2 avaliações",
    googleNote: "Consulte as avaliações reais no nosso perfil oficial ou deixe a sua.",
    viewReviews: "Ver avaliações",
    leaveReview: "Deixar uma avaliação ⭐",
  },
  assistant: {
    name: "Assistente Bloom",
    status: "Online",
    greeting: "Olá! 🌸 Bem-vinda à Bloom Beauty Concept Hair. Como posso ajudar?",
    placeholder: "Escreva a sua mensagem…",
    whatsapp: "Falar com Monique pelo WhatsApp",
    options: [
      { id: "eval", label: "Quero marcar uma avaliação" },
      { id: "services", label: "Quero conhecer os serviços" },
      { id: "mechas", label: "Tenho dúvidas sobre mechas" },
      { id: "progressiva", label: "Quero saber sobre progressiva" },
      { id: "treatments", label: "Quero saber sobre tratamentos" },
      { id: "location", label: "Onde fica o salão?" },
      { id: "hours", label: "Qual é o horário?" },
    ],
    answers: {
      eval: "Com todo o gosto! A avaliação profissional é o primeiro passo: analisamos a condição dos fios, o couro cabeludo, o histórico químico e o seu objetivo — com teste de mecha quando necessário. Posso encaminhá-la para a Monique no WhatsApp para marcar?",
      services: "Trabalhamos com Cortes & Finalização, Coloração, Iluminações, Mechas & Balayage, Correção de Cor, Tratamentos Capilares, Cronograma Capilar, Botox & Alinhamento e Progressiva & Alisamentos. Pode explorar cada especialidade na página de Serviços.",
      mechas: "As iluminações e mechas são criadas de acordo com o seu corte, tom de pele, base natural e objetivo. Transformações de cor podem exigir avaliação e teste de mecha — é assim que garantimos um resultado bonito e saudável.",
      progressiva: "A progressiva e os alisamentos deixam o cabelo alinhado, brilhante e sem frizz. A técnica ideal depende do comprimento, da densidade e da condição do fio — por isso tudo começa com uma avaliação.",
      treatments: "Temos hidratação, nutrição, reconstrução, detox capilar, cauterização e tratamentos premium. Na avaliação percebemos exatamente o que o seu cabelo precisa — água, lipídios ou proteínas.",
      location: "Estamos na Rua Casal dos Ninhos 1B, Venda do Pinheiro, 2665-536. Na página de Contacto encontra o botão «Como chegar».",
      hours: "Segunda a sexta: 09:00–19:00. Sábado: 09:30–18:00. Domingo: encerrado.",
      price: "Os valores variam consoante o serviço, o comprimento, a densidade e a condição do cabelo — por isso não publicamos preços. A Monique indica-lhe tudo com gosto, no WhatsApp ou numa avaliação.",
      fallback: "Para lhe responder com toda a atenção, o melhor é falar diretamente com a Monique. Posso encaminhá-la para o WhatsApp?",
    },
    keywords: {
      eval: ["marcar", "marcação", "agendar", "avaliação", "avaliacao", "reservar", "horário livre"],
      price: ["preço", "preco", "valor", "custa", "custo", "quanto", "tabela"],
      hours: ["horário", "horario", "aberto", "abre", "fecha", "sábado", "sabado", "domingo"],
      location: ["onde", "morada", "endereço", "endereco", "fica", "localização", "localizacao", "chegar"],
      mechas: ["mecha", "balayage", "loiro", "luzes", "iluminação", "iluminacao", "babylight"],
      progressiva: ["progressiva", "alisamento", "liso", "alisar"],
      treatments: ["tratamento", "hidratação", "hidratacao", "nutrição", "nutricao", "reconstrução", "reconstrucao", "botox", "cronograma", "frizz"],
      services: ["serviço", "servico", "serviços", "servicos", "corte", "coloração", "coloracao", "cor"],
    },
  },
  footer: {
    tagline: "Realçamos a sua beleza, revelamos a sua essência.",
    nav: "Navegação",
    contact: "Contacto",
    follow: "Siga-nos",
    hours: "Seg–Sex 09:00–19:00 · Sáb 09:30–18:00",
    rights: "Todos os direitos reservados.",
    privacy: "Política de Privacidade",
  },
  privacyPage: {
    title: "Política de Privacidade",
    updated: "Última atualização: setembro de 2026",
    sections: [
      { t: "Dados que recolhemos", d: "Quando nos contacta através do formulário ou do WhatsApp, recolhemos o seu nome, contacto telefónico, email e a sua mensagem, apenas para responder ao seu pedido e gerir marcações." },
      { t: "Como utilizamos", d: "Os dados são utilizados exclusivamente para comunicação consigo sobre os nossos serviços. Não vendemos nem partilhamos os seus dados com terceiros para fins de marketing." },
      { t: "Conservação", d: "Os dados são conservados apenas pelo tempo necessário à gestão do seu pedido e da relação de cliente." },
      { t: "Os seus direitos", d: "Pode solicitar acesso, retificação ou eliminação dos seus dados a qualquer momento, contactando-nos pelo telefone +351 963 085 891 ou pelo Instagram @monique_santoshairstylist." },
      { t: "Cookies", d: "Este website utiliza apenas ferramentas de análise anónima para melhorar a experiência de navegação." },
    ],
  },
  notFound: { title: "Página não encontrada", p: "O endereço que procura não existe ou foi movido.", cta: "Voltar ao início" },
  waDefault: "Olá Monique! Vi o website da Bloom Beauty Concept Hair e gostaria de obter informações/marcar uma avaliação.",
  waEval: "Olá Monique! Vi o website da Bloom e gostaria de marcar uma avaliação profissional.",
};

export default pt;
